module.exports = __webpack_public_path__ + "static/media/enable_notifications.d8882191.gif";